import { useState, useEffect } from 'react';
import { Spinner, Button } from 'components/Elements';
import { useActiveCustomers } from '../api/getActiveCustomers';
import { LayoutToggle } from './LayoutToggle';
import { UserCard } from './UserCard';

export const ActiveUsers = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [layout, setLayout] = useState('list');

  const activeCustomersQuery = useActiveCustomers({ pageNumber });

  if (activeCustomersQuery.isLoading) {
    return (
      <div className="w-full h-48 flex justify-center items-center">
        <Spinner size="sm" />
      </div>
    );
  }

  if (!activeCustomersQuery.data) return null;

  const { activeUsers, totalPages } = activeCustomersQuery.data;

  

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-white">Active Users</h2>
        <LayoutToggle current={layout} onChange={setLayout} />
      </div>

      <div
        className={layout === 'grid' ? 'grid grid-cols-4 gap-4' : 'space-y-3'}
      >
        {activeUsers.map((user) => (
          <UserCard key={user.id} user={user} layout={layout} />
        ))}
      </div>

      {/* Pagination Buttons */}
      <div className="flex justify-end gap-2">
        <Button
          size="sm"
          variant="ghost"
          onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
          disabled={pageNumber === 1}
        >
          Previous
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => setPageNumber((p) => p + 1)}
          disabled={pageNumber === totalPages}
        >
          Next
        </Button>
      </div>
    </div>
  );
};
